<!-- =========================================================================================
    File Name: User.vue
    Description: User page
========================================================================================== -->

<template>
  <div>
    <user-sidebar :isSidebarActive="updateDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
    <user-device-popup :isDevicePopupActive="devicePopupActive" @close="toggleDevicePopup" />
    <user-subscription-popup :isSubPopupActive="subPopupActive" @close="toggleSubscriptionPopup"/>
    <device-change-popup :isDeviceChangePopupActive="deviceChangePopupActive" @close="toggleDeviceChangePopup"/>
    <vx-card class="overflow-auto">
        <vs-button v-if="onlyAdmin" icon-pack="feather" icon="icon-shuffle" color="danger" @click="deviceChangePopup()">{{this.$t('REPLACE_DEVICE')}}</vs-button>
        <v-server-table id="user-table" ref="userTable" name="userTables"
            :columns="getColumn" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcel">
          <div slot="selected" slot-scope="props">
            <input v-model="selected" :value="props.row"  @click="select(props.row)" type="radio"/>
          </div>
          <vs-chip slot="userStatus" slot-scope="props" :color="getUserStatusColor(props.row.user.userStatus)" class="w-full">
            {{$t(setUserStatusName(props.row.user.userStatus))}}</vs-chip>
          <vs-button slot="serviceStatus" slot-scope="props" type="border" @click="devicePopup(props.row)" :color="getServiceStatusColor(props.row.device.serviceStatus)" class="w-full">
           {{$t(setServiceStatusName(props.row.device.serviceStatus))}}</vs-button>
          <vs-button slot="subscriberYn" slot-scope="props" type="border" @click="subscriptionPopup(props.row)" :color="getSubscriptionStatusColor(props.row.user.subscriberYn)" class="w-full">
            {{$t(valueOfSubscriptionStatus(props.row.user.subscriberYn))}}</vs-button>
          <div slot="edit" slot-scope="props">
             <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(props.row)" />
          </div>
           <div slot="link" slot-scope="props">
             <vs-dropdown vs-trigger-click >
              <feather-icon icon="LinkIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" />
              <vs-dropdown-menu>

              <router-link :to="{ path:'/user-file/'+props.row.user.userId}" target="_blank">
                <vs-dropdown-item>
                    <span class="text-dark">{{$t("UserFileList")}} </span>
                </vs-dropdown-item>
              </router-link>

              <router-link :to="{ path:'/streaming-play/'+props.row.user.userId}" target="_blank">
                <vs-dropdown-item>
                    <span class="text-dark">{{$t("StreamingPlayRecord")}}</span>
                </vs-dropdown-item>
              </router-link>
              
              <router-link :to="{ path: '/file-download-history/'+props.row.user.userId}" target="_blank">
                <vs-dropdown-item> 
                  <span class="text-dark">{{$t("FileDownloadHistory")}}</span>
                </vs-dropdown-item>
              </router-link>
              
              <router-link :to="{ path:'/file-upload-history/'+props.row.user.userId}" target="_blank"> 
                <vs-dropdown-item>
                    <span class="text-dark">{{$t("FileUploadHistory")}}</span>
                </vs-dropdown-item>
              </router-link>

              <router-link :to="{ path: '/subscription-payment/'+props.row.user.userId}" target="_blank"> 
                <vs-dropdown-item>
                    <span class="text-dark">{{$t("SubscriptionPaymentHistory")}}</span>
                </vs-dropdown-item>
              </router-link>

            </vs-dropdown-menu>
            </vs-dropdown>
             
          </div>
        </v-server-table>
    </vx-card>       
  </div>
</template>

<script>
window.axios = require('axios');
let FileSaver = require('file-saver');

import UserSidebar from './UserSidebar.vue'
import UserDevicePopup from './UserDevicePopup.vue'
import UserSubscriptionPopup from './UserSubscriptionPopup.vue'
import DeviceChangePopup from './DeviceChangePopup.vue'

import moduleUser from "@/store/user/moduleUser.js"

export default {
  components: {
    UserSidebar,
    UserDevicePopup,
    UserSubscriptionPopup,
    DeviceChangePopup
  },
  data() {
    return {
      // Data Sidebar
      updateDataSidebar: false,
      sidebarData: {},

      // Popup
      subPopupActive : false,
      devicePopupActive : false,
      deviceChangePopupActive: false,

      popupData:{},
      deviceData: {},
      subscriptionData: {},
      deviceChangeData: {},

      selected: '',
      selectedcheck: '',
      
      // Excel
      filter: {},
      sorted:{},

      // Table
      columns: ['selected', 'userId', 'email', 'userStatus', 'deviceUUID','serviceStatus', 'subscriberYn','link', 'edit'],
      userColumns: [ 'userId', 'email', 'userStatus', 'deviceUUID','serviceStatus', 'subscriberYn','link'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['userId', 'email', 'userStatus','deviceUUID', 'serviceStatus', 'subscriberYn'],
        sortable: ['userId', 'email', 'userStatus', 'serviceStatus', 'subscriberYn'],
        orderBy: { ascending: true },
        debounce: 1000,
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
            filterBy: this.$t("FILTER_BY"),
            defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'userId': () => this.$t("USER_ID"),
          'userStatus': () => this.$t("USER_STATUS"),
          'email': () => this.$t('EMAIL'),
          'edit': () => this.$t("EDIT"),
          'serviceStatus': () => this.$t("SERVICE_STATUS"),
          'subscriberYn': () => this.$t("SUBSCRIPTION_YN"),
          'link': () => this.$t("LINK"),
          'deviceUUID' : ()=> this.$t("DEVICE_UUID"),
          'selected': () => this.$t("SELECTED")
        },
        listColumns:{
          userStatus:[
            {
              id: '1',
              text: this.$t("ACTIVE")
            },
            {
              id: '2',
              text: this.$t("LOCKED")
            },
            {
              id: '3',
              text: this.$t("BLOCKED")
            }
          ],
          serviceStatus:[
            {
              id: '1',
              text: this.$t("IN_SERVICE")
            },
            {
              id: '0',
              text: this.$t("OUT_OF_SERVICE")
            }
          ],
          subscriberYn:[
            {
              id: 'Y',
              text: this.$t("SUBSCRIPTION_Y")
            },
            {
              id: 'N',
              text: this.$t("SUBSCRIPTION_N")
            }
          ],
        },
        requestAdapter: function(data) {
          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "userId",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        requestFunction: function (data) {
          return this.$http.get('/api/user-management/users', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataUser/SET_USER',response.data)
          return {
            data: this.$store.state.dataUser.userList,
            count: this.$store.state.dataUser.count
          }
        },
        templates:{
          userId: function(h,row){
            return row.user.userId;
          },
          email: function(h,row){
            return row.user.email;
          },
          adminStatus: function(h,row){
            return row.user.userStatus;
          },
          serviceStatus: function(h,row){
            return row.device.serviceStatus;
          },
          subscriberYn: function(h,row){
            return row.user.subscriberYn;
          },
          deviceUUID: function(h,row){
            return row.device.deviceUUID
          }
        }
      },
    }
  },
  computed:{
    onlyAdmin() {
      return this.$store.state.AppActiveUser.userRole === 'admin' ? this.$acl.check(this.$store.state.AppActiveUser.userRole) : false
    },
    getColumn(){
      if(this.$store.state.AppActiveUser.userRole === 'admin'){
        return this.columns
      }else{
        return this.userColumns
      }
    }
  },
  created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule('dataUser', moduleUser)
      moduleUser.isRegistered = true
    }

    this.$store.dispatch("dataUser/fetchUserStatus")
    this.$store.dispatch("dataUser/fetchUserBlockedReason")
    this.$store.dispatch("dataUser/fetchSubscriptionYN")
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.updateDataSidebar = val
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    // Popup
    toggleDevicePopup(val=false) {
      this.devicePopupActive = val
    },
    devicePopup(data){
      this.deviceData = {}
      this.devicePopupActive = true
      this.$store.commit('dataUser/SET_USER_INFO',data)
    },
    toggleSubscriptionPopup(val=false) {
      this.subPopupActive = val
    },
    subscriptionPopup(data){
      this.subscriptionData = {}
      this.subPopupActive = true
      this.$store.commit('dataUser/SET_USER_INFO',data)
    },
    toggleDeviceChangePopup(val=false) {
      this.deviceChangePopupActive = val
    },
    deviceChangePopup(){

      if(this.selected === ""){
        this.errorAlert(this.$t("ERROR"), this.$t("SELECT_USER_TO_REPLACE"))
      }else{
        this.deviceChangeData = {}
        this.deviceChangePopupActive = true
        this.$store.commit('dataUser/SET_DEVICE_CHANGE_POPUP', this.selected)
      }
    },
    getUserStatusColor(status) {
      return this.$store.state.commonConfig.userStatus.properties[status].color
    },
    setUserStatusName(status){
      return this.$store.state.commonConfig.userStatus.properties[status].name
    },
    getServiceStatusColor(status) {
      return this.$store.state.commonConfig.serviceStatus.properties[status].color
    },
    setServiceStatusName(status){
      return this.$store.state.commonConfig.serviceStatus.properties[status].name
    },
    getSubscriptionStatusColor(status) {
      if (status === 'N') return "danger"
      return "success"
    },
    valueOfSubscriptionStatus(status){
      if (status === 'Y') return "SUBSCRIPTION_Y"
      if (status === 'N') return "SUBSCRIPTION_N"
    },
    exportExcel(){

      let locale = this.$i18n.locale
      
      this.$http({
        method: 'post',
        url: '/api/user-management/users/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy:  this.sortForExcel.column ? this.sortForExcel.column : 'userId' ,
          ascending: this.sortForExcel.ascending ? 1 : 0
        },
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if (locale === "ko"){
          excelTitle = "고객_목록.xlsx"
        } else {
          excelTitle ="User_List.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    },
    select(props){
      this.selected = props      
    }
  },
}
</script>

<style lang="scss" scoped>
#user-table{
  text-align:center;
}
</style>